import {tutorialPageUrl, tutorialSectionUrl} from './links';

const legacy = true;

const legacyTutorialToNav = ({tutorial, page: currentPage, track}) => {
  const pages = tutorial.pages.nodes.map((page, index) => ({
    id: page.id,
    title: `${index + 1}. ${page.title}`,
    url: tutorialPageUrl({tutorial, page, legacy, track}),
    expanded: page.id === currentPage.id,
    sections: page.sections.nodes.map(section => ({
      id: section.id,
      title: `${section.title}`,
      url: tutorialSectionUrl({tutorial, page, section, legacy, track}),
    })),
  }));

  return {
    overview: {
      title: tutorial.title,
      id: tutorial.id,
    },
    pages,
  };
};

export default legacyTutorialToNav;
